import React, { ReactNode } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface YearsExperiencePopoverProps {
  skillName: string;
  currentYears: number | null;
  onSave: (years: number) => void;
  className?: string;
  endContent?: ReactNode;
}

const YearsExperiencePopover = ({
  skillName,
  currentYears,
  onSave,
  className,
  endContent
}: YearsExperiencePopoverProps) => {
  const [selectedYears, setSelectedYears] = React.useState<string>(
    currentYears?.toString() || "0"
  );
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    setSelectedYears(currentYears?.toString() || "0");
  }, [currentYears]);

  const handleSave = () => {
    onSave(parseInt(selectedYears));
    setIsOpen(false);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <div>
          <Badge
            variant="secondary"
            className={cn(
              "cursor-pointer",
              (!currentYears || currentYears === 0) && "bg-red-500 hover:bg-red-600",
              className
            )}
          >
            {skillName} • {(!currentYears || currentYears === 0) ? "?" : currentYears} yrs
            {endContent}
          </Badge>
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-60">
        <div className="grid gap-4">
          <div className="space-y-2">
            <h4 className="font-medium leading-none">Years of experience</h4>
            <p className="text-sm text-muted-foreground">
              Select years of experience for {skillName}
            </p>
          </div>
          <Select
            value={selectedYears}
            onValueChange={setSelectedYears}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select years" />
            </SelectTrigger>
            <SelectContent>
              {Array.from({ length: 21 }, (_, i) => (
                <SelectItem key={i} value={i.toString()}>
                  {i}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <div className="flex justify-end gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
            <Button
              size="sm"
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default YearsExperiencePopover;